import styled from "styled-components";
import {flexAdaptiveSizeItem, flexColumnContainerMixin} from "../../../../themes/architecture/css-helpers/flex";

export const GameWindowInnerWrapperBox = styled.div`
    ${flexColumnContainerMixin};
    ${flexAdaptiveSizeItem};
    max-width: 100%;
`;
